import React, { useState, useEffect } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Switch,
  FormControlLabel,
  Grid,
} from "@material-ui/core";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

const BotModal = ({ open, onClose, botId }) => {
  const initialState = {
    name: "",
    prompt: "",
    isActive: true,
    useAI: true,
    temperature: 0.7,
    maxTokens: 200,
    fallbackMessage: "",
  };

  const [bot, setBot] = useState(initialState);
  const [loading, setLoading] = useState(false);

  // 📥 cargar bot (modo edición)
  useEffect(() => {
    if (!botId) return;

    const fetchBot = async () => {
      try {
        const { data } = await api.get(`/bots/${botId}`);
        setBot(data);
      } catch (err) {
        toastError(err);
      }
    };

    fetchBot();
  }, [botId]);

  // reset al cerrar
  useEffect(() => {
    if (!open) {
      setBot(initialState);
    }
  }, [open]);

  // cambios en inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBot((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitch = (e) => {
    const { name, checked } = e.target;
    setBot((prev) => ({ ...prev, [name]: checked }));
  };

  // 💾 guardar
  const handleSave = async () => {
    try {
      setLoading(true);

      if (botId) {
        await api.put(`/bots/${botId}`, bot);
        toast.success("Bot actualizado");
      } else {
        await api.post("/bots", bot);
        toast.success("Bot creado");
      }

      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {botId ? "Editar Bot" : "Crear Bot"}
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>

          {/* Nombre */}
          <Grid item xs={12}>
            <TextField
              label="Nombre"
              name="name"
              value={bot.name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Prompt */}
          <Grid item xs={12}>
            <TextField
              label="Prompt del Bot"
              name="prompt"
              value={bot.prompt}
              onChange={handleChange}
              fullWidth
              multiline
              rows={6}
            />
          </Grid>

          {/* Fallback */}
          <Grid item xs={12}>
            <TextField
              label="Mensaje fallback"
              name="fallbackMessage"
              value={bot.fallbackMessage}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Switches */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={bot.isActive}
                  onChange={handleSwitch}
                  name="isActive"
                  color="primary"
                />
              }
              label="Bot activo"
            />

            <FormControlLabel
              control={
                <Switch
                  checked={bot.useAI}
                  onChange={handleSwitch}
                  name="useAI"
                  color="primary"
                />
              }
              label="Usar IA"
            />
          </Grid>

          {/* Parámetros IA */}
          <Grid item xs={6}>
            <TextField
              label="Temperature"
              name="temperature"
              type="number"
              inputProps={{ step: 0.1, min: 0, max: 1 }}
              value={bot.temperature}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Max Tokens"
              name="maxTokens"
              type="number"
              value={bot.maxTokens}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>

        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BotModal;